import { DialogCloseIcon } from "@/components/shared/dialog-close";
import { Dialog, DialogContent } from "@/components/ui";
import { useAuthState } from "@/store/auth";

import { EmailLoginContent } from "../email-login-content";

export const EmailLoginModal = () => {
  const {
    data: { emailLoginModalOpen },
    showModal,
  } = useAuthState();
  const onClose = () => {
    showModal();
  };
  return (
    <Dialog open={emailLoginModalOpen}>
      <DialogContent className="w-[343px]">
        <DialogCloseIcon onClose={onClose} />
        <EmailLoginContent />
      </DialogContent>
    </Dialog>
  );
};
